import { useEffect, useState } from 'react';

import { MOBILE_WIDTH } from '../constants/SizeConstants';

const getWindowDimensions = () => {
  const { clientWidth: width, clientHeight: height } =
    process.env.NODE_ENV === 'test' ? { clientWidth: 1024, clientHeight: 768 } : document.body;

  return {
    width,
    height,
    isMobileDevice: width <= MOBILE_WIDTH,
  };
};

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};
